import ACTIONS, { FETCH_STATUS } from "../constants";

export const getResourcesRequest = (state) => ({
  type: ACTIONS.RESOURCES_CALL,
  payload: state,
});

export const getResourcesAttempt = {
  pending: {
    type: ACTIONS.RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortResourcesAttempt = {
  pending: {
    type: ACTIONS.SORT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortResourcesRequest = (state) => ({
  type: ACTIONS.SORT_RESOURCES_CALL,
  payload: state,
});

export const updateResourceFlagAttempt = {
  pending: {
    type: ACTIONS.RESOURCE_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESOURCE_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESOURCE_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateResourceFlag = (state) => ({
  type: ACTIONS.RESOURCE_FLAG_CALL,
  payload: state,
});